import axios from 'axios'
import Vue from 'vue'
export default {
	GetLineasContrato (ContratoID) {
		return new Promise((resolve, reject) => {
			axios.get('radiacion/php/api/get-lineas-contrato.php?ContratoID=' + ContratoID)
				.then(res => {
					resolve(res.data)
				})
				.catch(e => {
					reject(e.response.error)
				})
		})
	},

	GetBloques (form) {
		return new Promise((resolve, reject) => {
			axios.post('radiacion/php/api/bloques/buscar.php', form)
				.then(res => {
					resolve(res.data)
				})
				.catch(e => {
					reject(e.response.error)
				})
		})
	},

	GetOriginales (filtro) {
		return new Promise((resolve, reject) => {
			axios.post('radiacion/php/api/originales/buscar.php', filtro)
				.then(res => {
					resolve(res.data)
				})
				.catch(e => {
					reject(e.response.data.error)
				})
		})
	},

	/**
	 * Devuelve la programación (bloques, programas y contenidos) de unos días dados
	 * Los días se pasarán como un array de fechas en formato 'YYYY-MM-DD'
	 */
	GetProgramacionDias (EmisoraID, dias) {
		const form = {
			EmisoraID: EmisoraID,
			Dias: dias.map(d => Vue.$moment(d).format('YYYY-MM-DD'))
		}

		return new Promise((resolve, reject) => {
			axios.post('radiacion/php/api/programacion/get-programacion-dias.php', form)
				.then(res => {
					resolve(res.data)
				})
				.catch(e => {
					reject(e.response.error)
				})
		})
	},

	/**
	 * Genera una nueva inserción en el día establecido y la devuelve
	 * @param {String} dia Fecha en Formato YYYY-MM-DD
	 */
	NuevaInsercion (dia) {
		const d = dia.split('-').map(d => parseInt(d))
		const diaUnix = Math.floor(new Date(d[0], d[1] - 1, d[2], 0, 0, 0, 0).getTime() / 1000)
		const insercion = {
			InsercionID: 'I-' + new Date().getTime() + Math.round(Math.random() * 100000),
			FicheroID: null,
			Inserciones: 1,
			Descripcion: null,
			Dia: dia,
			DiaUnix: diaUnix,
			UsuarioID: null,
			Bloques: [],
			Posicion: null,
			DuracionReal: 0,
			DuracionEstimada: 0,
			ImporteUnitario: 0,
			ImporteFinal: 0,
			Descuento: 0,
			ProgramaID: null,
			ProgramaNombre: null,
			ContenidoID: null,
			ContenidoNombre: null,
			HoraInicio: null,
			HoraFin: null,
			Fijar: null,
			Anulada: false,
			RefExterna: null
		}
		return insercion
	}
}



// WEBPACK FOOTER //
// ./src/modulos/radiacion/vue/servicios.js